import { NgModule } from '@angular/core';

import { CustomerPortalService } from './customer-portal.service';

@NgModule({
  providers: [
    CustomerPortalService
  ]
})
export class CustomerPortalModule {}
